import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { AccountCircle as IconUser } from "@mui/icons-material";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import { FORMATS, NOTIFY } from "common/config";
import { LABELS, WARNINGS, TITLES, SUB_TITLES } from "common/lables";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";

import { MASTER_APIs } from "apihandlers/master";
import { REPORTS_APIs } from "apihandlers/reports";
import { COLORS } from "common/colors";
import UiDialog from "components/Custom/UiDialog";
import TxtRow from "components/Custom/TxtRow";
import RichTxtBox from "components/Custom/RichTxtBox";
import RadioBtn from "components/Custom/RadioBtn";

const UnidentifiedTransactionUpdate = (props: any) => {
  const { setDashMenu } = props;

  const outletRef: any = useRef();

  const [loading, setLoading] = useState(false);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [masters, setMasters] = useState<any>([]);
  const [rows, setRows] = useState<any>(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [commentsList, setCommentsList] = useState([]);

  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [mandatoryLoadResults, setMandatoryLoadResults] = useState<any[]>([]);

  const [messageRow, setMessageRow] = useState<any>(
    selectedRow.messages ? selectedRow.messages : []
  );
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "date",
      name: LABELS.DATE,
      width: "15%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "amount",
      name: LABELS.AMOUNT,
      width: "20%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "bankDetails",
      name: LABELS.BANK_DETAILS,
      width: "20%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "comments",
      name: LABELS.COMMENTS,
      width: "30%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "status",
      name: LABELS.STATUS,
      width: "10%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (loading) {
      getOrgProfile();
    }
  }, [loading]);

  const getOrgProfile = () => {
    const args = {
      minResponse: true,
    };
    MASTER_APIs.getOrgProfiles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list: any = [{ id: -1, label: "All" }];
        let recs: any = response.records;
        for (let i = 0; i < recs.length; i++) {
          list.push({
            id: recs[i].id,
            label: recs[i].organizationName,
          });
        }
        setMasters(list);
        // setLoading(false);
      }
    });
  };

  const loadChart = () => {
    const outlet = outletRef.current.selectedValue.id;
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    const args = {
      fromDt,
      toDt,
      outlet,
      reportType: "excel",
    };
    let errors = [];
    if (!outlet) {
      errors.push({
        id: "outlet",
        msg:
          "<span class='bold'>" +
          LABELS.OUTLET +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (fromDt === "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    setRows([{}]);
    setLoading(false);
    //TODO API IS STILL IN PROGRESS

    // REPORTS_APIs.getDmsCurrentStock(args).then((res) => {
    //   const response: any = res.response;
    //   const { status } = res;
    //   if (status === 200) {
    //     for (let i = 0; i < response.rows.length; i++) {
    //       response.rows[i]["slNo"] = i + 1;
    //     }
    //     setRows(response.rows);
    //     setLoading(false);
    //   }
    // });
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
    setMessageRow([]);
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    setMessageRow(JSON.parse(row.feedbackDetails));
  };

  const reloadGrid = () => {
    setRows(null);
    loadChart();
  };

  const manageRecord = () => {
    const date = (
      document.getElementById("date") as HTMLInputElement
    ).value.trim();
    const amount = (
      document.getElementById("amount") as HTMLInputElement
    ).value.trim();
    console.log("date", date, amount);
    const bankDetails = (
      document.getElementById("bankDetails") as HTMLInputElement
    ).value.trim();
    const comments = (
      document.querySelector("#comments .ql-editor") as HTMLElement
    ).innerHTML;
    const op = document.querySelector(
      'input[name="status"]:checked'
    ) as HTMLInputElement;
    const status = op ? op.value : "";

    const args = {
      id: selectedRow.id || -1,
      date,
      amount,
      bankDetails,
      comments,
      status,
    };
    console.log("args", args);

    setSelectedRow({});
    setManageDialog(false);
    reloadGrid();

    // const areaId = areaRef.current.selectedValue.id;
    // const remarks =  (document.querySelector("#feedback .ql-editor") as HTMLElement
    // ).innerHTML;
    // // let ele = document.querySelector(
    // //   'input[name="activeStatus"]:checked'
    // // ) as HTMLInputElement;
    // // const activeStatus = ele ? ele.value : "";
    // //todo:Validations needs to be done
    // // Validations;
    // let errors = [];
    // if (personName === "") {
    //   errors.push({
    //     id: "personName",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.PERSON_NAME +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (!areaId) {
    //   errors.push({
    //     id: "area",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.AREA +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // setMandatoryResults(errors);
    // if (errors.length > 0) {
    //   COMMON_JS.showNotify(
    //     props,
    //     NOTIFY.WARNING,
    //     WARNINGS.PLEASE_CHECK_FORM_ERRORS
    //   );
    //   return;
    // }

    // setSelectedRow({});
    //     setManageDialog(false);
    //     reloadGrid();
    // setIsSubmit(true);
    //TODO API IS STILL IN PROGRESS

    // CUSTOMER_APIs.manageFeedback(args).then((res) => {
    //   setIsSubmit(false);
    //   if (res.status === 200) {
    //     COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
    //     setSelectedRow({});
    //     setManageDialog(false);
    //     reloadGrid();
    //   } else {
    //     COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
    //   }
    // });
  };

  let remarks: any = [
    { personName: "Karthik", feedbackDate: "18-09-2023", remarks: "Hello" },
  ];

  const onSaveRemarks = () => {
    setLoading(true);

    const personName = (
      document.getElementById("amount") as HTMLInputElement
    ).value.trim();
    const feedbackDate = (
      document.getElementById("bankDetails") as HTMLInputElement
    ).value.trim();

    const comments = (
      document.querySelector("#comments .ql-editor") as HTMLElement
    ).innerText;

    if (remarks.length > 0) {
      remarks = [
        ...remarks,
        {
          personName: personName,
          feedbackDate: feedbackDate,
          comments: comments,
        },
      ];
      setLoading(false);
    } else {
      remarks.push({
        personName: personName,
        feedbackDate: feedbackDate,
        comments: comments,
      });
      setLoading(false);
    }

    setCommentsList([
      ...commentsList,
      {
        personName: personName,
        feedbackDate: feedbackDate,
        comments: comments,
      },
    ]);
  };

  console.log("Page: CurrentStockWithDetails:", rows);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {TITLES.TRANSACTION}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.UNIDENTIFIED_TRANSACTIONS_UPDATE}</li>
        </ul>
        <h4>{TITLES.UNIDENTIFIED_TRANSACTIONS_UPDATE}</h4>
        <p>{SUB_TITLES.UNIDENTIFIED_TRANSACTIONS_UPDATE}</p>
      </div>

      <div className="hChart">
        <div
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
        >
          <div
            className="formGroup"
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: 5,
              marginBottom: 10,
              width: "40%",
            }}
          >
            <label>{LABELS.SELECT_OUTLET + " :"}</label>
            <AutoComplete
              id={"masters"}
              list={masters}
              childRef={outletRef}
              defaultValue={{ id: -1, label: "All" }}
            />
          </div>
          <div
            className="formGroup"
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: 0,
              marginBottom: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                marginRight: 15,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  fontWeight: "500",
                  fontSize: 14,
                  marginTop: 6,
                  marginRight: 8,
                }}
              >
                {LABELS.FROM_DATE}
              </label>
              <TxtBox
                type={"date"}
                id="fromDt"
                defaultValue={DateFunctions.getDate(
                  "today",
                  "from",
                  "YYYY-MM-DD"
                )}
              />
            </div>

            <div
              style={{
                display: "flex",
                marginRight: 15,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  fontWeight: "500",
                  fontSize: 14,
                  marginTop: 6,
                  marginRight: 8,
                }}
              >
                {LABELS.TO_DATE}
              </label>
              <TxtBox
                type={"date"}
                id="toDt"
                defaultValue={DateFunctions.getDate(
                  "thismonth",
                  "to",
                  "YYYY-MM-DD"
                )}
              />
            </div>

            <div
              style={{
                display: "flex",
                padding: 10,
                marginTop: "0.3rem",
              }}
            >
              <Btn
                text={LABELS.LOAD}
                onClick={loadChart}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </div>
        {mandatoryResults.length > 0 && (
          <div className="mandatoryBox">
            <ul>
              {mandatoryResults.map((m) => {
                return (
                  <li>
                    <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        <div className="grid excelGridWrapper">
          {!loading &&
            (rows ? (
              <ExcelGrid
                id={"unidentifiedTransactionsUpdate"}
                height={window.innerHeight * 0.8}
                cols={columns}
                rows={rows}
                exportOption={true}
                newRowOption={false}
                exportName={LABELS.UNIDENTIFIED_TRANSACTIONS_UPDATE}
                // onAdd={onAdd}
                // hideUnhide={true}
                onReload={reloadGrid}
              />
            ) : (
              <div className="flexCenter" style={{ minHeight: 450 }}>
                <Loader />
              </div>
            ))}
        </div>
        {manageDialog && (
          <UiDialog
            title={
              selectedRow.id
                ? "Edit " + TITLES.FEEDBACK + ": " + selectedRow.personName
                : "Add " + TITLES.FEEDBACK
            }
            open={true}
            size={"md"}
            onClose={() => {
              setManageDialog(false);
              setMandatoryResults([]);
              setMandatoryLoadResults([]);
            }}
          >
            <div className="flexColumn">
              <div className="formGroup  ">
                <TxtRow
                  id={"date"}
                  label={LABELS.DATE}
                  type={"date"}
                  defaultValue={
                    selectedRow.date
                      ? DateFunctions.getFormatedDate(
                          selectedRow.date,
                          FORMATS.DATE_ONLY,
                          FORMATS.SQL_DATE_ONLY
                        )
                      : DateFunctions.getDate(
                          "today",
                          "from",
                          FORMATS.SQL_DATE_ONLY
                        )
                  }
                  disabled={true}
                />
              </div>
              <div className="formGroup  ">
                <TxtRow
                  id={"amount"}
                  label={LABELS.AMOUNT}
                  defaultValue={selectedRow.id ? selectedRow.amount : ""}
                  type={"text"}
                  required={true}
                  disabled={true}
                />
              </div>
              <div className="formGroup  ">
                <TxtRow
                  id={"bankDetails"}
                  label={LABELS.BANK_DETAILS}
                  defaultValue={selectedRow.id ? selectedRow.bankDetails : ""}
                  type={"text"}
                  required={true}
                  disabled={true}
                />
              </div>
              <div className="formGroup  ">
                <label>{LABELS.COMMENTS}</label>
                <RichTxtBox id={"comments"} />
              </div>
              <div className="flexbtnjustify">
                <Btn
                  text={LABELS.SAVE}
                  onClick={onSaveRemarks}
                  loading={isSubmit}
                  bgColor={COLORS.SAVE_GREEN}
                />
              </div>
              {!loading && (
                <div className="width0">
                  <div>
                    <p style={{ fontWeight: "bold", paddingLeft: "1rem" }}>
                      {" Remarks"}
                    </p>
                  </div>
                  <div
                    style={{
                      height: "17rem",
                      overflowY: "scroll",
                      padding: "1rem 1rem 1rem 1rem",
                    }}
                  >
                    {commentsList &&
                      commentsList.map((items, index) => {
                        return (
                          <div id="responseList" key={index}>
                            <div>
                              <div>
                                <div className="responseHeader">
                                  <div className="userBox">
                                    <div>
                                      <IconUser />
                                    </div>
                                    <p
                                      style={{
                                        padding: "0rem 0rem 0.5rem 0.5rem",
                                      }}
                                    >
                                      {items.personName}
                                    </p>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <p
                                      style={{
                                        marginRight: 10,
                                      }}
                                    >
                                      {items.feedbackDate}
                                    </p>
                                  </div>
                                </div>
                                <div className="responseText">
                                  {items.comments}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}
              <div className="width30">
                <label>{LABELS.STATUS}</label>
                <RadioBtn
                  list={[
                    {
                      id: "open",
                      value: "open",
                      label: LABELS.OPEN,
                      checked: true,
                      disabled: false,
                    },
                    {
                      id: "close",
                      value: "close",
                      label: LABELS.CLOSED,

                      disabled: false,
                    },
                  ]}
                  row={true}
                  name={"status"}
                  // disabled={isSubmit}
                />
              </div>

              {/* <div className="formGroup  ">
              <label>{LABELS.USER}</label>
              
              <AutoComplete
                list={users}
                childRef={usersRef}
                // defaultValue={
                //   selectedRow.userId
                //     ? {
                //         id: selectedRow.userId,
                //         label: selectedRow.name,
                //       }
                //     : null
                // }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div> */}

              {/* <div className="formGroup required">
              <label>
                {LABELS.ACTIVE_STATUS}
                <span>*</span>
              </label>
              <RadioBtn
                list={[
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.ACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "Yes"
                      : true,
                    disabled: isSubmit,
                  },
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.INACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "No"
                      : false,
                    disabled: isSubmit,
                  },
                ]}
                row={true}
                name={"activeStatus"}
                required={true}
                disabled={isSubmit}
              />
            </div> */}

              {/* <div
              className="grid"
              style={{
                width: "100%",
                height: "80%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ExcelGrid
                id={"message"}
                height={600}
                childRef={messageGridRef}
                cols={messageColumns}
                rows={messageRow}
                exportOption={false}
                newRowOption={false}
                getDefaultNewRow={getDeaultItemRow}
              />
            </div> */}
              {/* mandatoryResults */}
              {mandatoryResults.length > 0 && (
                <div className="mandatoryBox">
                  <ul>
                    {mandatoryResults.map((m) => {
                      return (
                        <li>
                          <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
              <div className="formGroup submitBtnWrapper">
                <div className="flexbtnjustify">
                  <Btn
                    text={LABELS.CANCEL}
                    bgColor={COLORS.RELOAD_EXPORT}
                    color={COLORS.RELOAD_EXPORT_TEXT}
                    onClick={() => {
                      setManageDialog(false);
                      setMandatoryResults([]);
                      setMandatoryLoadResults([]);
                    }}
                    loading={isSubmit}
                  />
                  <Btn
                    text={LABELS.SAVE}
                    onClick={manageRecord}
                    loading={isSubmit}
                    bgColor={COLORS.SAVE_GREEN}
                  />
                </div>
              </div>
            </div>
          </UiDialog>
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(UnidentifiedTransactionUpdate);
